/**
 * Created by tao.li on 2018/2/27.
 */
import axios from 'axios';
import conf from '../config/config';
import cookie from '../utils/cookie';
import { isUndefOrEmpty } from '../utils/util';
import Vue from 'vue';
import dsBridge from 'dsbridge';
import router from '../router/index';

//window._axiosPromiseArr = [];

const service = axios.create({
    timeout: 600000,
    auth: true,
    baseURL: window.location.origin,
    method: 'post',
    loading: true // 是否显示loading
});

const METHOD_MAP = {
    'get': 'params',
    'post': 'data'
};

// cookie.remove('access_token');
// cookie.remove('access_token', {domain: location.hostname});

// 获取app的登录信息
let loginInfo = JSON.parse(window.dsBridge.call('getLoginMsg') || '{}');
cookie.set("lang", (loginInfo.langType || cookie.get("lang") || 'en-US'));
if(loginInfo.mvnoCode || cookie.get("mvnoCode")) cookie.set("mvnoCode", (loginInfo.mvnoCode || cookie.get("mvnoCode")));
if(loginInfo.access_token || cookie.get('access_token')) cookie.set('access_token', loginInfo.access_token || cookie.get('access_token') || '');

service.interceptors.request.use(config => {
    if(config.loading) Vue.$vux.loading.show();

    /*config.cancelToken = new axios.CancelToken(cancel => {
        window._axiosPromiseArr.push({cancel});
    });*/

    let authParams = {
    };

    let commonParams = {
        streamNo: conf.request.streamNoHead + (new Date()).getTime() + parseInt(Math.random() * 1000000),
        partnerCode: conf.request.partnerCode,
        langType: loginInfo.langType || cookie.get("lang") || 'en-US',
        loginCustomerId: loginInfo.loginCustomerId || cookie.get('loginCustomerId') || '',
        mvnoCode: loginInfo.mvnoCode || cookie.get('mvnoCode') || 'GCGROUP',
        mvnoId: loginInfo.mvnoId || cookie.get('mvnoId') || null,
        orgId: loginInfo.orgId || cookie.get('orgId') || '',
        access_token: loginInfo.access_token || cookie.get('access_token') || ''
    };

    /*
    * 添加通用参数
    * */
    config.headers["Accept-Language"] = loginInfo.langType || cookie.get("lang") || "en-US";
    config.headers["app_version"] = loginInfo.app_version;
    config.headers["access_token"] = loginInfo.access_token || cookie.get('access_token');
    if(!config.noCommon) {
        config[METHOD_MAP[config.method]] = {
            ...commonParams,
            ...config[METHOD_MAP[config.method]]
        };
    } else {
        config[METHOD_MAP[config.method]] = {
            ...config[METHOD_MAP[config.method]],
        };
    }


    /*
    * 添加验证参数
    * */
    if(config.auth === true){
        config[METHOD_MAP[config.method]] = {
            ...config[METHOD_MAP[config.method]],
            ...authParams
        };
    }
    /*
    * 过滤值为空参数
    * */
    config[METHOD_MAP[config.method]] && Object.keys(config[METHOD_MAP[config.method]]).forEach((val) => {
        if( isUndefOrEmpty(config[METHOD_MAP[config.method]][val])) {
            delete config[METHOD_MAP[config.method]][val];
        }
    });

    return config;
}, error => {
    return Promise.reject(error);
});

service.interceptors.response.use(
  response => {
    Vue.$vux.loading.hide();

    let resultCode = response.data.resultCode;
    let resultDesc = response.data.resultDesc;

    if(resultCode === '00000000') {
      return response.data;
    } else {
        if(resultCode === '00000008' || resultCode === '00000007' || resultCode === '00000006') {
            /*
             * 00000008 => AccessToken does not belong to the loginCustomer
             * 00000007 => The access token expired
             * 00000006 => AccessToken is null
             * */
            window.dsBridge.call('nativeLogin');
        } else {

          if(!resultCode){
            return Promise.resolve(response.data);
          }else{
            return Promise.reject(response.data);
          }
        }
    }
  },
  error => {
    Vue.$vux.loading.hide();
    // 跳转到网络错误页面
    router.push({
        name: 'net-error'
    });
    return Promise.reject('');
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js